import { sortBy } from 'lodash'
import type { HierarchiesApiResponse } from './tmsApi'
import { tmsApi } from './tmsApi'

export const enhancedTmsApi = tmsApi.enhanceEndpoints({
  addTagTypes: ['TMViews', 'GAViews', 'schedule-report'],
  endpoints: {
    getTrainingMatrixViews: {
      providesTags: ['TMViews']
    },
    createTrainingMatrixView: {
      invalidatesTags: ['TMViews']
    },
    updateTrainingMatrix: {
      invalidatesTags: ['TMViews']
    },
    deleteTrainingMatrix: {
      invalidatesTags: ['TMViews']
    },
    getGapAnalysisViews: {
      providesTags: ['GAViews']
    },
    createGapAnalysisView: {
      invalidatesTags: ['GAViews']
    },
    updateGapAnalysisView: {
      invalidatesTags: ['GAViews']
    },
    deleteGapAnalysis: {
      invalidatesTags: ['GAViews']
    },
    trainingMatrixReports: {
      providesTags: ['schedule-report']
    },
    createTrainingMatrixReport: {
      invalidatesTags: ['schedule-report']
    },
    updateTrainingMatrixReport: {
      invalidatesTags: ['schedule-report']
    },
    deleteTrainingMatrixReport: {
      invalidatesTags: ['schedule-report']
    },
    hierarchies: {
      transformResponse: (response: HierarchiesApiResponse) => {
        return sortBy(response, hierarchy => hierarchy.weight)
      }
    },
    trainingMatrixExcel: {
      query: arg => ({
        url: `/training-matrix/dynamic/${arg.reportHash}/export`,
        params: {
          style: arg.style,
          showGroups: arg.showGroups,
          showManagers: arg.showManagers,
          hierarchies: arg.hierarchies,
          showOverallPercentageOfCompliance: arg.showOverallPercentageOfCompliance,
          showPercentageOfComplianceForIndividuals: arg.showPercentageOfComplianceForIndividuals,
          showPercentageOfComplianceForCompetencies: arg.showPercentageOfComplianceForCompetencies,
          showPercentageOfComplianceForCompetencyGroups: arg.showPercentageOfComplianceForCompetencyGroups,
          useColorBlindPalette: arg.useColorBlindPalette
        },
        responseHandler: async response => {
          return window.URL.createObjectURL(await response.blob())
        },
        cache: 'no-cache'
      }),
      keepUnusedDataFor: 0
    },
    gapAnalysisExcel: {
      query: arg => ({
        url: `/gap-analysis/dynamic/${arg.reportHash}/export`,
        params: { visibleColumns: arg.visibleColumns },
        responseHandler: async response => {
          return window.URL.createObjectURL(await response.blob())
        },
        cache: 'no-cache'
      }),
      keepUnusedDataFor: 0
    }
  }
})
